import type { TableState } from '@casino/craps-engine';

export interface ForfeitPlan {
  /** Total cents that will be lost if the player leaves now. */
  forfeitCents: number;
  /** Bet ids that removeBet refuses (pass/dontPass flats during POINT). */
  forfeitIds: string[];
}

/**
 * Contract bets the player cannot take down: a pass or don't-pass flat with an
 * established point. Mirrors engine.removeBet's guard
 * (engine.ts: `(type === 'pass' || type === 'dontPass') && phase === 'POINT'`).
 * Everything else — odds, place, come, field, props, ATS — is refunded by
 * removeBet, so it is not forfeited.
 */
export function computeForfeit(state: TableState): ForfeitPlan {
  if (state.phase !== 'POINT') return { forfeitCents: 0, forfeitIds: [] };
  const contract = state.bets.filter((b) => b.type === 'pass' || b.type === 'dontPass');
  return {
    forfeitCents: contract.reduce((s, b) => s + b.amount, 0),
    forfeitIds: contract.map((b) => b.id as string),
  };
}
